<script setup lang="ts">
import AppBar from "~/components/App/AppBar.vue"
import NavDrawer from "~/components/App/NavDrawer.vue"
</script>

<template>
  <div>
    <AppBar />
    <NavDrawer />
    <v-main class="px-4 my-4">
      <div class="page-content-centred">
        <div class="mb-6"><NuxtLink to="/faq">FAQ</NuxtLink></div>
        <slot />
      </div>
    </v-main>
  </div>
</template>

<style scoped lang="scss">
.page-content-centred {
  margin: 0 auto;
  max-width: 768px;
}
</style>
